"use client";

import { createIcon } from "@chakra-ui/react";

const PlusSvgIcon = createIcon({
  displayName: "PlusSvgIcon",
  viewBox: "0 0 16 16",
  path: (
    <path d="M7.99831 13.9291L7.9972 2.06641M2.06641 7.99722L13.9291 7.99832" stroke="currentColor" stroke-width="2" stroke-linejoin="bevel"/>
  ),
});

export default PlusSvgIcon;
